import { render, staticRenderFns } from "./viewAssignedStaff.vue?vue&type=template&id=95de4538&"
import script from "./viewAssignedStaff.vue?vue&type=script&lang=js&"
export * from "./viewAssignedStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95de4538')) {
      api.createRecord('95de4538', component.options)
    } else {
      api.reload('95de4538', component.options)
    }
    module.hot.accept("./viewAssignedStaff.vue?vue&type=template&id=95de4538&", function () {
      api.rerender('95de4538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/viewAssignedStaff.vue"
export default component.exports